import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'polylearn-lerobert-home2',
  templateUrl: './home2.component.html',
  styleUrls: ['./home2.component.scss', '../styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LeRobertHome2Component implements OnInit {
  buttons = [
    {
      text: 'Consulter le programme<br>de formation',
      link:
        'https://drive.google.com/file/d/1hj6Y7MD42q5CnSfFSVZqDrdslRlz_Rrz/view?usp=sharing'
    },
    {
      text: 'Je souhaite me former<br>avec mon CPF',
      link:
        'https://www.moncompteformation.gouv.fr/espace-prive/html/#/formation/recherche/39329104200157_FLR2h302022/39329104200157_FLR2h302022'
    }
  ];

  sections1 = {};

  section2 = {
    contents: [
      {
        header: {
          logo: 'logo-formation-le-robert',
          title: 'Mesurer son niveau<br>et progresser'
        },
        body: [
          {
            title: 'La plateforme en ligne au parcours individualisé',
            subTitle: '10 heures de formation personnalisée',

            items: [
              "<b style='  color: #0090d7;'>Une pédagogie solide et innovante</b> appuyée sur l’expertise reconnue du Robert, couvrant toutes les facettes de la langue française : orthographe, grammaire, vocabulaire et expression",
              "<b style='  color: #0090d7;'>4 modules pédagogiques complémentaires</b> pour monter à son rythme en compétence : Test de positionnement / Cours / Entraînement / Tests blancs",
              "<b style='  color: #0090d7;'>Une technologie « adaptive learning »</b> s’adaptant à l’utilisateur tout en prenant en compte les données d’apprentissage des autres utilisateurs"
            ],
            img: 'formation'
          },
          {
            title: 'Une équipe de formateurs hautement qualifiés et pédagogues',
            subTitle: '2 h 30 d’accompagnement individuel',
            img: 'equipe',
            items: [
              "<b style='  color: #0090d7;'>Un accompagnement individualisé à distance</b> avec des formateurs de haut niveau, répondant aux exigences pédagogiques et linguistiques du Robert",
              "<b style='  color: #0090d7;'>Des conseils méthodologiques à chaque étape</b> de la formation : utilisation, notions de cours à privilégier en fonction des résultats sur la plateforme, fiches de règles à étudier"
            ]
          }
        ]
      },

      {
        header: {
          logo: 'logo-certification-le-robert',
          title: 'S’évaluer<br>et se certifier'
        },
        body: [
          {
            title:
              'La seule certification globale en langue française : orthographe, grammaire, expression et vocabulaire',
            subTitle: '1 h 45 de test en centre La Poste',
            img: 'certification',
            items: [
              "<b style='  color: #0090d7;'>Permet d’attester d’un niveau de français</b>, notamment en milieu professionnel : un atout incontournable pour un CV",
              "<b style='  color: #0090d7;'>Évaluation complète</b> : 350 questions testant toutes les compétences de la langue française, conçues sur le même référentiel que la Formation Le Robert"
            ]
          }
        ]
      },

      {
        header: {
          logo: 'logo-horizontal-le-robert-correcteur',
          title: 'Consolider ses acquis<br>et se perfectionner'
        },
        body: [
          {
            title: 'Un logiciel PC/Mac d’aide à la rédaction et de correction',
            subTitle: 'Toujours à portée de main',
            img: 'robert-correcteur',
            items: [
              "<b style='  color: #0090d7;'>Une correction de qualité professionnelle grâce à une technologie de pointe</b> : son moteur de correction orthographique, syntaxique et grammaticale tire parti d’une intelligence artificielle dernier cri pour vous permettre de corriger vos erreurs",
              "<b style='  color: #0090d7;'>Compatible PC et Mac</b>, il s’intègre directement aux logiciels de traitement de texte les plus utilisés (Word, Outlook, PowerPoint, Open Office, Pages, Keynote, Mail…) pour toujours rester à portée de clic",
              "<b style='  color: #0090d7;'>8 dictionnaires de référence et 6 guides linguistiques Le Robert</b> sont aussi inclus"
            ]
          }
        ]
      }
    ]
  };

  section3 = {
    items: [
      {
        title: 'Découverte, test initial et tutorat',
        subTitle: '1 heure sur la plateforme + 30 minutes avec le tuteur',
        description:
          'Vous effectuerez un test de positionnement pour mesurer votre niveau de départ et définir vos objectifs avec votre tuteur.'
      },
      {
        title: 'Entraînement personnalisé et tutorat',
        subTitle: '4 heures sur la plateforme + 30 minutes avec le tuteur',
        description:
          'Exercez-vous et mesurez vos progrès grâce au tableau de bord et comblez vos lacunes.'
      },
      {
        title: 'Entraînement personnalisé et tutorat',
        subTitle: '1 h 30 sur la plateforme + 1 h 30 avec le tuteur',
        description:
          'Dans la perspective du passage de la Certification Le Robert, entraînez-vous à mobiliser et maintenir votre concentration et levez les dernières difficultés avec votre tuteur.'
      },
      {
        title: 'Examens blancs',
        subTitle: '4 heures sur la plateforme + 30 minutes avec le tuteur',
        description:
          'Passez un ou plusieurs examens blancs pour vous mettre dans les conditions de l’examen et évaluer une dernière fois votre niveau.'
      },
      {
        title: 'Passage de la Certification Le Robert',
        subTitle: '2 heures en centre La Poste',
        description:
          '50 centres en France ou passage à distance, le jour et à l’heure de votre choix.'
      }
    ]
  };

  constructor() {}

  ngOnInit(): void {}
}
